import styled from 'styled-components'


export const SideWrapper = styled.section `
@import url('https://fonts.googleapis.com/css?family=Sen&display=swap');
    background: #44495D ;
    max-width: 20rem;
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-right:1px solid #666;
    font-family: 'Sen', sans-serif;
    z-index: 1;
    //position: fixed;


  img{
        width: 8rem;
        height:8rem;
        background:none;
        border-radius: 6px;
        margin-bottom: 20px;
    }

    h1{
        color: #fff;
        background: none;
        margin-top: 2rem;
    }
    h2{
        color:#fff;
    }
    h3{
        color: #F77B57;
        background:none;
        font-weight: normal;
        font-size: 20px;
    }
    p{
        color: #999;
        background:none;
    }
    span{
        background: none;
    }
    ul{
        background:none;
    }

`
